import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { User } from 'lucide-react';
import { userService, UserProfile } from '../../services/userService';

interface UserAvatarProps {
  size?: number;
  className?: string;
}

const AvatarContainer = styled.div<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme }) => theme.colors.text.secondary};
  border: 2px solid ${({ theme }) => theme.colors.border.primary};
`;

const AvatarImage = styled.img<{ size: number }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const DefaultIcon = styled.div<{ size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const UserAvatar: React.FC<UserAvatarProps> = ({ size = 32, className }) => {
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const profile = await userService.getCurrentUser();
        setUserProfile(profile);
      } catch (error) {
        console.error('Failed to fetch user profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  if (loading) {
    return (
      <AvatarContainer size={size} className={className}>
        <DefaultIcon size={size}>
          <User size={size * 0.6} />
        </DefaultIcon>
      </AvatarContainer>
    );
  }

  return (
    <AvatarContainer size={size} className={className}>
      {userProfile?.profileImage ? (
        <AvatarImage 
          src={userProfile.profileImage} 
          alt={userProfile.name || 'User'}
          size={size}
        />
      ) : (
        <DefaultIcon size={size}>
          <User size={size * 0.6} />
        </DefaultIcon>
      )}
    </AvatarContainer>
  );
};

export default UserAvatar;

